import { trimSlash } from './trim.js'

export const DEFAULT_APP_PUBLIC_ORIGIN = 'https://demo-compute.dataobserve.io'

/** User-visible app origin (share links, demo URLs). Override with VITE_APP_PUBLIC_ORIGIN. */
export function getAppPublicOrigin() {
  const explicit = import.meta.env.VITE_APP_PUBLIC_ORIGIN
  if (explicit && String(explicit).trim()) {
    return trimSlash(String(explicit).trim())
  }
  return DEFAULT_APP_PUBLIC_ORIGIN
}

/** @param {string} [path=''] */
export function buildAppPublicUrl(path = '') {
  const origin = getAppPublicOrigin()
  if (!path) return origin
  const normalizedPath = path.startsWith('/') ? path : `/${path}`
  return `${origin}${normalizedPath}`
}
